import { render, staticRenderFns } from "./listaUsuarios.vue?vue&type=template&id=06f85962&scoped=true"
import script from "./listaUsuarios.vue?vue&type=script&lang=js"
export * from "./listaUsuarios.vue?vue&type=script&lang=js"
import style0 from "./listaUsuarios.vue?vue&type=style&index=0&id=06f85962&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f85962",
  null
  
)

export default component.exports